import React, { useCallback, useEffect, useState } from "react"
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import DatatableTables from "../../globals/core/Tables/DatatableTables";
import { useDispatch, useSelector } from "react-redux";
import { setModalChild, setModalState } from "../../store/actions/modalActions";
import { AddNewContentForm } from "./AddNewContentForm";
import { ContentItemPreview } from "./ContentItemPreview";
import {
  getContent,
  getCommunities,
  setCurrentContent,
  getUsers,
  searchContent,
} from "../../store/actions/contentActions";
import { ContentItem } from "hc-entities";
import { TagsService } from "../../globals/services/tags.service";
import { showLoader } from "../../store/actions/mainActions";
import { truncate } from "../../globals/helpers/helpers";
import { TooltipStatement } from "../../globals/core/TooltipStatement/TooltipStatement";
import moment from "moment";
import { QuickPostForm } from "./QuickPostForm";
import { ContentService } from "../../globals/services/content.service";


export const Content = (props) => {
  const dispatch = useDispatch();
  const { contentItems } = useSelector((state) => state.content);

  const openAddNewContentModal = () => {
    dispatch(setCurrentContent(undefined));
    dispatch(setModalState(true));
    dispatch(setModalChild(<AddNewContentForm afterPostAction={update} />));
  };

  const openContentItemPreview = (content) => {
    dispatch(setCurrentContent(content));
    dispatch(setModalState(true));
    dispatch(setModalChild(<ContentItemPreview afterPostAction={update} />));
  };

  const openQuickPostForm = () => {
    dispatch(setCurrentContent(null));
    dispatch(setModalState(true));
    dispatch(setModalChild(<QuickPostForm action="create" afterPostAction={update} />));
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      const content = new ContentItem(contentItems[row.tableIndex]);
      content.tags = content.tags ? content.tags : [];
      openContentItemPreview(content);
    },
  };

  /**
   * This function is getting important data and dependencies
   */
  const update = useCallback(async () => {
    dispatch(showLoader(true))
    await dispatch(getContent());
    await dispatch(getCommunities())
    await dispatch(getUsers())
    dispatch(showLoader(false))
  }, [dispatch])

  useEffect(() => {
    update()
  }, [update]);

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "title",
      text: "TITLE",
      sort: true,
      formatter: (cell) => {
        return cell && typeof cell === 'string' ? <TooltipStatement
          shorten={truncate(cell, 30, '...')}
          statement={cell}
        /> : ""
      },
      sortValue: (cell) => {
        return cell;
      },
      searchValue: (cell) => {
        return cell;
      },
      searchable: true
    },
    {
      dataField: "type",
      text: "CONTENT TYPE",
      sort: true,
    },
    {
      dataField: "u_name",
      text: "UPLOADED BY",
      sort: true,
    },
    // {
    //   dataField: "created",
    //   text: "DB DOCUMENT CREATED",
    //   sort: true,
    // },
    {
      dataField: "created_on",
      text: "DATE CONTENT CREATED ON",
      sort: true,
      formatter: (cell) => {
        if (cell?.length > 0) {
          return moment(new Date(cell)).format("DD/MM/YYYY")
        }
        else return "No date provided"
      },
      sortValue: (cell) => {
        return cell;
      },
      searchValue: (cell) => {
        return cell;
      },
      searchable: true
    },
    {
      dataField: "c_name",
      text: "CREATED BY",
      sort: true,
    },
    {
      dataField: "modified",
      text: "LAST MODIFIED ON",
      sort: true,
    },
    {
      dataField: "m_name",
      text: "MODIFIED BY",
      sort: true,
    },
    {
      dataField: "publish_amount",
      text: "TIMES PUBLISHED",
      sort: true,
    },
  ];

  const filterToTooltips = () => {
    const items = [...contentItems.map(c => ({ ...c }))]
    let tableIndex = 0;
    return items.map((i) => {
      i['tableIndex'] = tableIndex;
      tableIndex++;
      return i
    })
  }


  const debounce = (fn, delay) => {
    return function (...args) {
      if (window.timeoutID) {
        clearTimeout(window.timeoutID);
      }
      window.timeoutID = setTimeout(() => {
        fn(...args)
      }, delay)
    }
  }


  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MAIN" breadcrumbItem="HARTMAN CONTENT" />
          <div className="row my-4">
            <div className="col-6 d-flex ">
              <button
                className="btn btn-outline-primary"
                onClick={openAddNewContentModal}
              >
                Add new item +
              </button>
              <button
                className="btn btn-outline-primary mx-3"
                onClick={openQuickPostForm}
              >
                Quick Post
              </button>
            </div>
          </div>
          <DatatableTables
            columns={columns}
            data={
              filterToTooltips()
            }
            title={"Content Items"}
            desc={"Recent Items in Hartman Connect"}
            rowEvents={rowEvents}
            search
            searchOverride={{
              onSearch: async (event) => {
                const debounceSearch = debounce(async () => {
                  dispatch(showLoader(true))
                  await dispatch(searchContent(event))
                  dispatch(showLoader(false))
                }, 500);
                debounceSearch();
              },
              onClear: async (event) => {
                const debounceSearch = debounce(async () => {
                  dispatch(showLoader(true))
                  await dispatch(getContent(event))
                  dispatch(showLoader(false))
                }, 200);
                debounceSearch();
              },
            }}
          ></DatatableTables>
        </div>
      </div>
    </div>
  );
};


//SHARED BETWEEN POPUPS
export const searchTagsAction = async (query) => {
  try {
    const tagsService = TagsService()
    const tags =  await tagsService.search(query)
    return tags.map((c)=> ({label : c , value :c}));
  } catch (err) {
    console.error(err);
  }
}

export const searchRelatedAction = async (term) => {
  try {
    const contentService = ContentService();
    const content = await contentService.searchContentItems(term);
    return content.filter(c=>c.type !== 'quick_post').map(c=> ({label : c.title , value : c.content_id, media: c.file_type, url: c.link}));
  } catch (err) {
    console.error(err);
  }
}